import { FC } from 'react';
import clsx from 'clsx';
import type { AnalyticsPlatform } from 'api/new-analytics/types';

export interface LegendItem {
  label: string;
  color: string;
  platform?: AnalyticsPlatform;
  id?: string;
}

interface ChartLegendProps {
  items: LegendItem[];
  className?: string;
}

const ChartLegend: FC<ChartLegendProps> = ({ items, className }) => {
  return (
    <div
      className={clsx(
        'tw-flex tw-w-full tw-flex-wrap tw-items-center tw-gap-4 tw-overflow-hidden ',
        className,
      )}
      data-cy="analytics-chart-legend"
    >
      {items.map((item) => {
        const rowKey = item.id ?? item.label;
        return (
          <div
            key={rowKey}
            className="tw-flex tw-min-w-0 tw-max-w-full tw-items-center tw-gap-2"
            data-cy={`analytics-chart-legend-item-${rowKey}`}
          >
            <div
              className="tw-h-3 tw-w-3 tw-shrink-0 tw-rounded"
              style={{ backgroundColor: item.color }}
            />
            <span className="tw-min-w-0 tw-truncate tw-text-xs tw-font-medium tw-leading-4 tw-text-grayscale-180">
              {item.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ChartLegend;
